import React from 'react'

function PageUnderDevelopment() {
  return (
    <div>Page is Under Development</div>
  )
}

export default PageUnderDevelopment